<template>
  <div class="col-md-12 questions">
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Profile Questions
      </label>

      <div class="col-sm-10">
        <button
          type="button"
          class="btn btn btn-primary"
          @click="addQuestion"
        >
          Add More
        </button>
      </div>
    </div>
    <div class="form-group row">
      <div
        v-if="questionItems.length"
        class="col-sm-10 offset-2"
      >
        <div
          v-for="(question, index) in questionItems"
          :key="index"
          class="row mb-1 add-new-question"
        >
          <div class="col-sm-9">
            <textarea
              v-model="questionItems[index].question"
              class="form-control"
              name="question[]"
              rows="3"
            />
            <input
              type="hidden"
              name="projectId[]"
              :value="question.id"
            >
          </div>
          <div class="col-md-3">
            <button
              type="button"
              class="btn btn btn-danger"
              @click="removeQuestion(index)"
            >
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'ProfileQuestions',
    props:{
        questions: {
            type: Array,
            default: () => []
        }
    },
    data: function () {
        return {
            questionItems: [],
            defaultQuestion: 'Can you discuss XXXXX? Please elaborate in 1-2 sentences on your work experience.',
        }
    },
    mounted (){
        this.questionItems = this.questions.length ? this.questions.map(question => ({id: question.id, question: question.question})) : []
    },
    methods: {
        addQuestion () {
            this.questionItems.push({
                id: Buffer.from(_.uniqueId('question_'), 'utf8').toString('base64'),
                question: this.defaultQuestion,
            })
        },
        removeQuestion: function ( index ) {
           Vue.delete(this.questionItems, index)
        },
    }
}
</script>

<style scoped>

</style>
